function toTitleCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const ViewHelper = {
  toTitleCase,
};

export default ViewHelper;
